export default {
  listRecord: null,
  loading: false,
  status: false
}
